import { useSelector } from "react-redux";

export const useAuth = () => {
  const userSignIn = useSelector((state) => state?.LoginCheckSlice?.data?.data);

  const loggedIn = ((userSignIn?.auth_token != undefined && userSignIn?.auth_token != null) || (localStorage.getItem("auth_token") != undefined && localStorage.getItem("auth_token") != null)) ? true : false;
  // console.log("userSignIn?.auth_token", userSignIn?.auth_token, localStorage.getItem("auth_token"), loggedIn)
  return loggedIn;
};
